export default "__VITE_ASSET__PKu7hbpK__"